import React, { useContext } from 'react';

import LedgerContext from './contexts/LedgerContext';
import BulkActions from './components/actions/BulkActions';
import BulkActionsHelpers from './components/actions/BulkActionsHelpers';
import CustomPagination from './components/pagination/CustomPagination';
import TableData from './components/table/TableData';

import Box from '../Box/Box';
import HStack from '../HStack/HStack';

const LedgerContent = props => {
  const { id, bulkActions, columns, search, filter, actions, pagination, filterComponent } = props;
  const { selected, visibleColumns } = useContext(LedgerContext);

  const isBulkSelected = selected && selected.length > 0;

  const Actions = actions;

  const hasTopActions =
    actions ||
    search ||
    visibleColumns ||
    (filter && filter.groups && filter.groups.length > 0) ||
    filterComponent ||
    bulkActions;

  return (
    <>
      {hasTopActions && (
        <Box bottom="19px">
          <HStack align="distributed" alignY="center" spacing="none">
            <HStack align="left" alignY="center" spacing="medium">
              {isBulkSelected && <BulkActions bulkActions={bulkActions} />}
              <BulkActionsHelpers
                columns={columns}
                search={search}
                filter={filter}
                id={id}
                filterComponent={filterComponent}
              />
            </HStack>
            {!isBulkSelected && (
              <HStack align="right" alignY="center" spacing="medium">
                {Actions && <Actions />}
              </HStack>
            )}
          </HStack>
        </Box>
      )}
      <TableData {...props} />
      {!isBulkSelected && <CustomPagination pagination={pagination} />}
    </>
  );
};

export default LedgerContent;
